export class ProjectUser {

    public user: number;
    public isMainClient: boolean;
    public isMainBusiness: boolean;
    public active: boolean;
}
